import React, { Component } from "react";
import { toPersianNumber } from "../../classes/utils";

import "./Footer.css";

// import enamadImage from " "

class Footer extends Component {
    constructor(props) {
        super(props);
    }
    state = {};
    render() {
        let { mobile, phone, address, zip } = this.props.contact_info || {};
        return (
            <div className="Footer">
                <div className="row info">
                    <div className="information">
                        <div className="caption">اطلاعات</div>
                        <div>
                            <div className="info">
                                <div className="name">
                                    <i className="fa-solid fa-location-dot"></i>
                                    آدرس
                                </div>
                                <div>
                                    {address ||
                                        "استان اصفهان - مبارکه - حسن آباد "}
                                </div>
                            </div>
                            {zip && (
                                <div className="info">
                                    <div className="name">
                                        <i className="fa-solid fa-envelopes-bulk"></i>
                                        کد پستی
                                    </div>
                                    <div>{toPersianNumber(zip)}</div>
                                </div>
                            )}
                            <div className="info">
                                <div className="name">
                                    <i className="fa-solid fa-phone"></i>
                                    تماس
                                </div>
                                <div>
                                    {mobile && (
                                        <a href="tel:+989131234567">
                                            {toPersianNumber(mobile)}
                                        </a>
                                    )}
                                    <br />
                                    {phone && (
                                        <a href="tel:+983112345678">
                                            {toPersianNumber(phone)}
                                        </a>
                                    )}
                                </div>
                            </div>
                            <div className="info">
                                <div className="name">
                                    <i className="fa-brands fa-instagram"></i>
                                    اینستاگرام
                                </div>
                                <a href="https://www.instagram.com/kharazie_nika/">
                                    پیج اینستاگرام خرازی نیکا
                                </a>
                            </div>

                            <div className="info">
                                <div className="name">
                                    <i className="fa-solid fa-at"></i>
                                    ایتا
                                </div>
                                <a href="https://eitaa.com/kharazienika">
                                    کانال ایتا خرازی نیکا 
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="links">
                        <div className="caption">لینک ها</div>

                        <a href="/" id="home">
                            <i className="ri-home-3-line"></i>
                            صفحه اصلی
                        </a>
                        <a href={"/costumer"}>
                            <i className="ri-user-3-fill"></i>پنل مشتری
                        </a>

                        <a href="/follow-up" id="orderTracking">
                            <i className="fa-solid fa-truck-fast"></i>
                            پیگیری سفارش
                        </a>

                        <a
                            href="https://tracking.post.ir/"
                            className="postal_tracking"
                        >
                            <i className="fa-solid fa-map-location-dot"></i>
                            رهگیری پستی
                        </a>
                        <a href="/pay/offline" id="orderTracking">
                            <i className="fa-solid fa-file-invoice-dollar"></i>
                            ثبت فیش واریز
                        </a>
                        <a href="/rules" id="rules">
                            <i className="fa-solid fa-scale-balanced"></i>
                            قوانین سایت
                        </a>
                        <a href="/about-us" id="about">
                            <i className="ri-information-line"></i>
                            درباره ما
                        </a>
                    </div>
                    <div className="certs">
                        <div className="caption">تاییدیه ها</div>

                        <div className="e-namad">
                            نماد اعتماد الکترونیک(اینماد)
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: `
                                    <a
                                    referrerPolicy="origin"
                                    target="_blank"
                                    href="https://trustseal.enamad.ir/?id=426549&Code=FvHddP6OgVGjWUKthcKQylPBN3PhESlM"
                                >
                                    <img
                                        referrerPolicy="origin"
                                        src="https://trustseal.enamad.ir/logo.aspx?id=426549&Code=FvHddP6OgVGjWUKthcKQylPBN3PhESlM"
                                        alt=""
                                        loading="lazy"
                                        style="cursor:pointer;"
                                        id="FvHddP6OgVGjWUKthcKQylPBN3PhESlM"
                                        code="FvHddP6OgVGjWUKthcKQylPBN3PhESlM"
                                    />
                                </a>`,
                                }}
                            ></div>
                            {/* <a
                                referrerPolicy="origin"
                                target="_blank"
                                href="https://trustseal.enamad.ir/?id=426549&Code=FvHddP6OgVGjWUKthcKQylPBN3PhESlM"
                            >
                                <img
                                    referrerPolicy="origin"
                                    src="https://trustseal.enamad.ir/logo.aspx?id=426549&Code=FvHddP6OgVGjWUKthcKQylPBN3PhESlM"
                                    alt=""
                                    loading="lazy"
                                    style={{ cursor: "pointer" }}
                                    id="FvHddP6OgVGjWUKthcKQylPBN3PhESlM"
                                    code="FvHddP6OgVGjWUKthcKQylPBN3PhESlM"
                                />
                            </a> */}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="rights">
                        <div className="EN">
                            All rights reserverd for
                            <h2>Nika Online Shop</h2> .
                        </div>
                        <div>
                            تمامی حقوق مادی و معنوی این وبسایت متعلق به{"    "}
                            <h2>فروشگاه اینترنتی نیکا </h2>
                            میباشد.
                        </div>
                        <div>
                            طراحی و اجرا : محمد جواد حاجی دولو
                            <a href="mailto:mhajidavallu@gmail.com">
                                ایمیل طراح
                            </a>
                        </div>
                        {/* <a href="mailto:mhajidavallu@gmail.com">
                            mhajidavallu@gmail.com
                        </a>
                        <div className="EN">
                            Designed and Developed By :
                            <a href="mailto:mhajidavallu@gmail.com">
                                Mohammad Javad Hajidavallu
                            </a>
                        </div> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;
